import UnauthenticatedContent from 'app/components/auth/UnauthenticatedContent';
import { isAuthenticatedSelector } from 'app/models/auth/selectors';
import { connect } from 'react-redux';

export default connect((state) => ({
  isAuthenticated: isAuthenticatedSelector(state),
}))(UnauthenticatedContent);
